import React, {useEffect, useState} from 'react';
import {v4 as uuidv4} from "uuid";
import { toast, ToastContainer } from 'react-toastify';
import dynamicAPI from '../api/dynamicAPI';
export const InputImagesBlock = ({
                                     label,
                                     name,
                                     register,
                                     setValue,
                                     fileInputs,
                                     setFileInputs,
                                     images_path, // Base path for images
                                     maxImages,
                                     t
                                 }) => {

    const [rotatingIds, setRotatingIds] = useState([]); // 🔄 Track rotating images

    useEffect(() => {
        // Register the images field in react-hook-form
        register(name);
    }, [register, name]);

    const addFileInput = () => {
        setFileInputs(prevInputs => {
            // Only add new input if the limit has not been reached
            if (prevInputs.length < maxImages) {
                return [...prevInputs, {
                    id: uuidv4(),
                    operation: "create",
                    file: null
                }];
            }
            return prevInputs;
        });
    };

    const handleFileChange = (e, id) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const newInputs = fileInputs.map(input => {
                    if (input.id === id) {
                        return {
                            ...input,
                            operation: input.operation === "keep" ? "update" : input.operation,
                            file: file,
                            imageData: reader.result,
                            imagePath: file.name
                        };
                    }
                    return input;
                });
                setFileInputs(newInputs);
                // Update the form field with the new list of images
                updateFormImages(newInputs);
            };
            reader.readAsDataURL(file);
        }
    };

    const removeFileInput = (id) => {
        let updatedInputs = fileInputs.map(input => {
            if (input.id === id) {
                // Determine the action based on the input's current operation
                switch (input.operation) {
                    case 'create':
                        // For 'create', we actually want to remove the input completely
                        return null; // Mark for deletion, will be filtered out
                    case 'keep':
                        // If currently 'keep', mark this input's operation as 'remove'
                        return {...input, operation: 'remove'};
                    case 'update':
                        // If currently 'update', mark this input's operation as 'remove'
                        return {...input, operation: 'remove'};
                    case 'remove':
                        // If already 'remove', switch back to 'update' as a safety, or handle as needed
                        return {...input, operation: 'update'};
                    default:
                        // No change for inputs that don't match the specific ID
                        return input;
                }
            }
            return input;
        }).filter(input => input !== null); // Filter out the inputs marked for deletion

        setFileInputs(updatedInputs);
        // Update the form field with the new list of images
        updateFormImages(updatedInputs);
    };

    // Synchronize file inputs with the form field
    const updateFormImages = (inputs) => {
        const imagesData = inputs.filter(input => input.file).map(input => input.file);
        setValue(name, imagesData); // Use setValue from react-hook-form to update the form field
    };
    const rotateImage = async (id) => {
        setRotatingIds(prev => [...prev, id]);

        try {
            const result = await dynamicAPI('post', '/api/auth/edit-space-image', {
                id,
                action: 'rotate'
            });

            const newImagePath = result.imagePath;

            const updatedInputs = fileInputs.map(input =>
                input.id === id
                    ? {
                        ...input,
                        imagePath: newImagePath + `?ts=${Date.now()}`
                    }
                    : input
            );

            setFileInputs(updatedInputs);
            toast.success(t("Image rotated successfully!"));
        } catch (error) {
            console.error("Failed to rotate image:", error);
            toast.error(t("Failed to rotate image."));
        } finally {
            setRotatingIds(prev => prev.filter(_id => _id !== id));
        }
    };



    const isRotating = (id) => rotatingIds.includes(id);

    return (
        <div className='mb-3'>
            <label>{label}</label>
            <div className="file-input-container mb-3">
                {fileInputs.map((input) => (
                    <div key={input.id} className="images-container-input" data-operation={input.operation}>
                        {/*{console.log(input)}*/}
                        <div className="thumbnail-input-img">
                            <ToastContainer />

                            <img
                                src={input?.imagePath ?? images_path + 'item-no-image.png'}
                                alt="Thumbnail"
                            />
                            {input.operation === "keep" && (
                                <button
                                    className="thumbnail-input-rotate"
                                    type="button"
                                    onClick={() => rotateImage(input.id)}
                                    disabled={isRotating(input.id)} // 🔄 Disable if rotating
                                >
                                    {isRotating(input.id) ? (
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                                    ) : (
                                        <>🔄 {t("Rotate")}</>
                                    )}
                                </button>
                            )}
                        </div>
                        <div className="thumbnail-container-inputs">
                            <div className="thumbnail-container-input-id">{input.imagePath}</div>

                            <div className="thumbnail-container-input">
                                <input {...register(name)}
                                       type="file"
                                       className='form-control'
                                       id={input.id}
                                       onChange={e => handleFileChange(e, input.id)}
                                />
                            </div>

                            <button className="thumbnail-input-remove" type="button"
                                    onClick={() => removeFileInput(input.id)}>
                                {input.operation === "remove" ? "X" : t("Remove")}
                            </button>
                        </div>
                    </div>
                ))}
                {fileInputs.length < maxImages && (
                    <button type="button" className="thumbnail-file-input-add" onClick={addFileInput}>
                        {t("Add Image")}
                    </button>
                )}
            </div>
        </div>
    );
};

const isAllowedExtension = ['jpg', 'jpeg', 'png'];

const getFileExtension = (filename) => {
    return filename.split('.').pop().toLowerCase();
};

export const checkImageFiles = (fileInputs) => {
    const images = [];
    for (const fileInput of fileInputs) {
        // Ensure there is a file object to check
        console.log(fileInput);
        if (!fileInput.imageData) {
            // isError(true);
            // setError('images', { type: 'manual', message: 'NO DATA FOUND TO SAVE FOR THIS IMAGE.' });
            console.log("NO imageData SET FOR IMAGE - WILL SKIP IT");
            continue;
        }

        if (fileInput.file && fileInput.file.type) {
            // Extract the file extension directly from the file name
            const fileExtension = getFileExtension(fileInput.file.name);
            if (!isAllowedExtension.includes(fileExtension)) {
                throw new Error(`Invalid file extension for ${fileInput.file.name}`);
            }
        }
        // Push the relevant data to the images array; adapt as needed
        images.push({
            id: fileInput.id,
            operation: fileInput.operation,
            imageData: fileInput.imageData
        });

        console.log('PUSHING IMAGE:', fileInput);
    }

    return images;
};
